module.exports = __webpack_public_path__ + "assets/img/shouquan_bg.70547bd4.png";